module.exports = __webpack_public_path__ + "img/service-10.e5df3c73.png";